"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const XHRClient_1 = __importDefault(require("../XHRClient"));
const genericResponse_1 = require("./types/genericResponse");
const Utils_1 = require("../../Shared/Utils/Utils");
const EstablishSession_1 = require("./calls/EstablishSession/EstablishSession");
const GetOddsLadder_1 = require("./calls/GetOddsLadder/GetOddsLadder");
const ListFreeBetEntitlements_1 = require("./calls/ListFreeBetEntitlements/ListFreeBetEntitlements");
const GetPunterDetails_1 = require("./calls/GetPunterDetails/GetPunterDetails");
const AddPunterTaggedValue_1 = require("./calls/AddPunterTaggedValue/AddPunterTaggedValue");
const GetPunterPreferences_1 = require("./calls/GetPunterPreferences/GetPunterPreferences");
const ListPunterTaggedValues_1 = require("./calls/ListPunterTaggedValues/ListPunterTaggedValues");
const UpdatePunterPreferences_1 = require("./calls/UpdatePunterPreferences/UpdatePunterPreferences");
const UpdatePunterDetails_1 = require("./calls/UpdatePunterDetails/UpdatePunterDetails");
const GetAccountStatement_1 = require("./calls/GetAccountStatement/GetAccountStatement");
class IAPIClient extends XHRClient_1.default {
    constructor(params) {
        super(params);
        this.header = {
            fragmentLanguage: 'Javascript',
            clientIdentifier: '',
            version: 2,
            fragmentVersion: '',
        };
        this.orderCacheInterval = null;
        this.orderCache = null;
        this.maxSequenceNo = 0;
        this.arbRefreshID = 0;
        this.storeSessionTokenInCookieWithExpiryTime = false;
        this.version = {
            implementationVersion: '15.1.0',
        };
        this.sessionTokenCookieName = 'IAPISessionToken';
        this.userContextCookieName = 'GECUserContext';
        this.telebetSessionToken = null;
        this.aapiVersion = '2.2';
        this.controllerDefaults = {
            language: 'en',
            integrationPartnerId: 0,
            currency: 'EUR',
            organisationalUnitId: 1,
            priceFormat: 1,
        };
        this.getOddsLadder = GetOddsLadder_1.getOddsLadder.bind(this);
        this.listFreeBetEntitlements = ListFreeBetEntitlements_1.listFreeBetEntitlements.bind(this);
        this.getPunterDetails = GetPunterDetails_1.getPunterDetails.bind(this);
        this.listPunterTaggedValues = ListPunterTaggedValues_1.listPunterTaggedValues.bind(this);
        this.getPunterPreferences = GetPunterPreferences_1.getPunterPreferences.bind(this);
        this.addPunterTaggedValue = AddPunterTaggedValue_1.addPunterTaggedValue.bind(this);
        this.updatePunterPreferences = UpdatePunterPreferences_1.updatePunterPreferences.bind(this);
        this.updatePunterDetails = UpdatePunterDetails_1.updatePunterDetails.bind(this);
        this.getAccountStatement = GetAccountStatement_1.getAccountStatement.bind(this);
        this.establishSession = EstablishSession_1.establishSession.bind(this);
        this.passwordValidityRegExp =
            this.initializationParams.passwordValidityRegExp;
    }
    async establishUserSession(params) {
        const request = {
            header: this.header,
            ...params,
        };
        request.integrationPartnerId =
            this.initializationParams.integrationPartnerId;
        request.currency = 'GBP';
        request.language = 'en';
        request.granularChannelType = 5;
        request.channelInformation = 'GEP-exchange-D~Windows~Browser-1.3142|';
        request.initialLanguage = 'en';
        request.numberLogonAttemptsToReturn = 3;
        const response = await this.sendRequest('establishSession.ashx', request);
        this.sessionToken = response.sessionToken;
        return response;
    }
    async getBalance() {
        if (this.sessionToken === undefined) {
            throw 'no session';
        }
        const request = {
            header: this.header,
            sessionToken: this.sessionToken,
        };
        return await this.sendRequest('getBalance.ashx', request);
    }
    async listGenericTaggedValues(params) {
        const request = {
            header: this.header,
            sessionToken: this.sessionToken,
            integrationPartnerId: this.initializationParams.integrationPartnerId,
            ...params,
        };
        return await this.sendRequest('listGenericTaggedValues.ashx', request);
    }
    setDefaultValues(params) {
        this.controllerDefaults.language = params.language;
        if (params.integrationPartnerId != null) {
            this.controllerDefaults.integrationPartnerId =
                params.integrationPartnerId;
        }
        this.controllerDefaults.currency = params.currency;
        if (params.organisationalUnitId != null) {
            this.controllerDefaults.organisationalUnitId =
                params.organisationalUnitId;
        }
        this.controllerDefaults.priceFormat = params.priceFormat;
        if (params.isSessionPresent != undefined) {
            this.initializationParams.isSessionPresent = params.isSessionPresent;
        }
        if (params.clientIdentifier !== undefined) {
            this.header.clientIdentifier = params.clientIdentifier.replace('{gecversion}', this.version.implementationVersion);
        }
    }
    async setUserContext(params) {
        if (this.telebetSessionToken == null) {
            throw {
                returnCode: genericResponse_1.ReturnCode.NotTelebetUserSession,
                message: 'NotTelebetUserSession',
            };
        }
        const request = {
            header: this.header,
            telebetSessionToken: this.telebetSessionToken,
            ...params,
        };
        let response = {};
        await this.sendRequest('establishSession.ashx', request).then((data) => {
            this.sessionToken = data.sessionToken;
            response = data;
            response.partnerUsername = request.partnerUsername;
            this.userContext = response;
        });
        return response;
    }
    async clearUserContext() {
        if (this.telebetSessionToken == null) {
            throw {
                number: genericResponse_1.ReturnCode.NotTelebetUserSession,
                message: 'NotTelebetUserSession',
            };
        }
        else {
            if (this.orderCacheInterval != null) {
                window.clearInterval(this.orderCacheInterval);
            }
            this.clearUserContextVariables();
        }
    }
    async endUserSession(params) {
        if (this.userContext === undefined) {
            throw { number: genericResponse_1.ReturnCode.NotUserSession, message: 'NotUserSession' };
        }
        else {
            const terminateSessionRequest = {
                header: this.header,
                sessionToken: this.sessionToken,
                ...params,
            };
            await this.sendRequest('terminateSession.ashx', terminateSessionRequest).then(() => {
                this.initializationParams.isSessionPresent = false;
            });
            if (this.storeSessionTokenInCookieWithExpiryTime) {
                Utils_1.GBETUtils.deleteCookie(this.sessionTokenCookieName);
                Utils_1.GBETUtils.deleteCookie(this.userContextCookieName);
            }
            this.clearUserContextVariables();
            window.clearInterval(this.arbRefreshID);
        }
    }
    async getExternalSystemToken(params) {
        if (this.userContext === undefined) {
            throw { returnCode: genericResponse_1.ReturnCode.AnonymousOperationNotSupported };
        }
        const request = {
            header: this.header,
            sessionToken: this.sessionToken,
            ...params,
        };
        return await this.sendRequest('getExternalSystemToken.ashx', request);
    }
    async performCustomService(params) {
        const request = {
            header: this.header,
            integrationPartnerId: this.controllerDefaults.integrationPartnerId,
            sessionToken: this.sessionToken,
            language: this.userContext != null
                ? this.userContext.language
                : this.controllerDefaults.language,
            ...params,
        };
        const customServicesThatDontRequireSessionToken = [
            'nyra.IsLocationRequiredForEstablishSession',
            'IsUsernameAlreadyUsed',
            'NYRA.ResendEmail',
            'EnterOntrackADWContest',
        ];
        if (customServicesThatDontRequireSessionToken.includes(params.customServiceName)) {
            if (this.sessionToken) {
                console.error('The custom service ' +
                    params.customServiceName +
                    ' is being called when a GEC session already exists, which should not happen.');
            }
        }
        else {
            request.sessionToken = this.sessionToken;
        }
        return await this.sendRequest('performCustomService.ashx', request);
    }
    async enrolPunter(params) {
        if (params.cleartextPassword !== undefined &&
            !this.checkPasswordValidity({ password: params.cleartextPassword })) {
            throw { returnCode: genericResponse_1.ReturnCode.InvalidPassword /* InvalidPassword */ };
        }
        const request = {
            header: this.header,
            ...params,
        };
        if (this.sessionToken != null) {
            request.sessionToken = this.sessionToken;
        }
        else {
            request.username = params.username;
            if (params.integrationPartnerId != null) {
                request.integrationPartnerId = params.integrationPartnerId;
                request.purseIntegrationMode = params.purseIntegrationMode;
            }
        }
        request.title = params.titleId || params.title;
        request.sex = params.sexId || params.sex;
        request.firstQuestionType =
            params.firstQuestionTypeId || params.firstQuestionType;
        request.secondQuestionType =
            params.secondQuestionTypeId || params.secondQuestionType;
        request.contactType = params.contactTypeId || params.contactType;
        request.forOrderRepriceOption =
            params.forOrderRepriceOptionId || params.forOrderRepriceOption;
        request.againstOrderRepriceOption =
            params.againstOrderRepriceOptionId || params.againstOrderRepriceOption;
        request.channelInformation =
            '-GEC' +
                this.version.implementationVersion +
                '|' +
                params.channelInformation;
        return await this.sendRequest('enrolPunter.ashx', request).then((resp) => {
            if (resp.returnCode == genericResponse_1.ReturnCode.Success ||
                resp.returnCode == genericResponse_1.ReturnCode.PunterFailedIdentityVerificationCheck) {
                if (resp.sessionToken != null) {
                    this.sessionToken = resp.sessionToken;
                    //delete resp.sessionToken;
                    if (this.userContext != null &&
                        resp.punterClassificationName !== undefined) {
                        this.userContext.punterClassificationName =
                            resp.punterClassificationName;
                    }
                }
            }
        });
    }
    async continuePunterEnrolment(params) {
        if (params.cleartextPassword !== undefined &&
            !this.checkPasswordValidity({ password: params.cleartextPassword })) {
            throw { returnCode: genericResponse_1.ReturnCode.InvalidPassword /* InvalidPassword */ };
        }
        const request = {
            questions: params.answers,
            sessionToken: '',
            header: this.header,
            ...params,
        };
        if (this.sessionToken != null) {
            request.sessionToken = this.sessionToken;
        }
        return await this.sendRequest('continuePunterEnrolment.ashx', request).then((resp) => {
            if (resp.returnCode === genericResponse_1.ReturnCode.Success) {
                if (resp.sessionToken != null) {
                    this.sessionToken = resp.sessionToken;
                    if (this.userContext != undefined) {
                        this.userContext.punterClassificationName =
                            resp.punterClassificationName;
                    }
                    delete resp.sessionToken;
                }
            }
        });
    }
    async enrolPunterAsynchronously(params) {
        if (params.cleartextPassword !== undefined &&
            !this.checkPasswordValidity({ password: params.cleartextPassword })) {
            throw { returnCode: genericResponse_1.ReturnCode.InvalidPassword /* InvalidPassword */ };
        }
        const request = {
            header: this.header,
            ...params,
        };
        if (this.sessionToken != null) {
            request.sessionToken = this.sessionToken;
        }
        else {
            request.username = params.username;
            if (params.integrationPartnerId != null) {
                request.integrationPartnerId = params.integrationPartnerId;
                request.purseIntegrationMode = params.purseIntegrationMode;
            }
        }
        request.title = params.titleId || params.title;
        request.sex = params.sexId || params.sex;
        request.firstQuestionType =
            params.firstQuestionTypeId || params.firstQuestionType;
        request.secondQuestionType =
            params.secondQuestionTypeId || params.secondQuestionType;
        request.contactType = params.contactTypeId || params.contactType;
        request.forOrderRepriceOption =
            params.forOrderRepriceOptionId || params.forOrderRepriceOption;
        request.againstOrderRepriceOption =
            params.againstOrderRepriceOptionId || params.againstOrderRepriceOption;
        request.channelInformation =
            '-GEC' +
                this.version.implementationVersion +
                '|' +
                params.channelInformation;
        return await this.sendRequest('enrolPunter.ashx', request);
    }
    async checkEnrolmentStatus(params) {
        const request = {
            header: this.header,
            ...params,
        };
        return await this.sendRequest('checkEnrolmentStatus.ashx', request);
    }
    clearUserContextVariables() {
        this.orderCacheInterval = null;
        this.userContext = undefined;
        this.sessionToken = undefined;
        this.orderCache = null;
        this.maxSequenceNo = 0;
    }
    checkPasswordValidity(params) {
        // If no regular expression set, all passwords are valid
        if (this.passwordValidityRegExp === undefined) {
            return true;
        }
        // Check against regular expression
        return (new RegExp(this.passwordValidityRegExp).exec(params.password) !== null);
    }
}
exports.default = IAPIClient;
